import React, { Component } from 'react';
import { Modal as BModal } from 'react-bootstrap';
import { Button, SelectSearch, Table, Icon, Input } from '../../../../components';
import { Globals } from '../../../../utils';
import axios from '../../../../utils/axios';
import moment from 'moment';

class ModalProductPromoted extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            start_date: '',
            end_date: '',
            selected_product: null,
            products_list: [], // [{ product_id, product_name, product_code }]
            
            all_products: [],
            loading: false
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show) {
            this.loadSelects();
            if (this.props.data) {
                // Modo Edición
                const campaign = this.props.data;
                const products = campaign.products ? campaign.products.map(p => ({
                    product_id: p.product_id,
                    product_name: p.product ? p.product.name : 'Desconocido',
                    product_code: p.product ? p.product.code : ''
                })) : [];

                this.setState({
                    id: campaign.id,
                    start_date: moment(campaign.start_date).format('YYYY-MM-DD'),
                    end_date: moment(campaign.end_date).format('YYYY-MM-DD'),
                    products_list: products,
                    selected_product: null
                });
            } else {
                // Modo Creación
                this.setState({
                    id: null,
                    start_date: '',
                    end_date: '',
                    products_list: [],
                    selected_product: null
                });
            }
        }
    }

    loadSelects = async () => {
        this.setState({ loading: true });
        try {
            const res = await axios.post('admin/discounts/get-selects', { user_id: this.props.user_id });
            if (res.data && res.data.products) {
                this.setState({
                    all_products: res.data.products.map(p => ({
                        value: p.id,
                        label: `${p.name} (${p.code || 'Sin código'})`,
                        code: p.code,
                        name: p.name,
                        product: p
                    })),
                    loading: false
                });
            }
        } catch (error) {
            console.error('Error fetching selects:', error);
            this.setState({ loading: false });
        }
    }

    handleAddProduct = () => {
        const { selected_product, products_list } = this.state;
        if (!selected_product || !selected_product.value) {
            return Globals.showError('Seleccione un producto para agregar');
        }

        const exists = products_list.some(p => p.product_id === selected_product.value);
        if (exists) {
            return Globals.showError('El producto ya está en la lista');
        }

        this.setState({
            products_list: [...products_list, {
                product_id: selected_product.value,
                product_name: selected_product.name || (selected_product.product && selected_product.product.name),
                product_code: selected_product.code || (selected_product.product && selected_product.product.code)
            }],
            selected_product: null
        });
    }

    handleRemoveProduct = (index) => {
        const list = [...this.state.products_list];
        list.splice(index, 1);
        this.setState({ products_list: list });
    }

    save = async () => {
        const { id, start_date, end_date, products_list } = this.state;
        const { user_id, onSuccess, onClose } = this.props;

        if (!start_date) return Globals.showError('La fecha de inicio es requerida');
        if (!end_date) return Globals.showError('La fecha de fin es requerida');
        if (moment(end_date).isBefore(moment(start_date))) {
            return Globals.showError('La fecha final debe ser mayor o igual a la inicial');
        }
        if (products_list.length === 0) {
            return Globals.showError('Debe agregar al menos un producto a la lista');
        }

        Globals.setLoading('Guardando...');
        try {
            const payload = {
                user_id,
                start_date,
                end_date,
                products: products_list.map(p => p.product_id)
            };

            let res;
            if (id) {
                payload.id = id;
                res = await axios.post('admin/inventory/products-promoted/edit', payload);
            } else {
                res = await axios.post('admin/inventory/products-promoted/create', payload);
            }

            if (res.data.result) {
                Globals.showSuccess(res.data.message || 'Campaña guardada exitosamente');
                if (onSuccess) onSuccess();
                if (onClose) onClose();
            } else {
                Globals.showError(res.data.message || 'Error al guardar');
            }
        } catch (error) {
            console.error('Error saving promoted campaign:', error);
            Globals.showError(error.response?.data?.message || 'Ocurrió un error inesperado al guardar');
        } finally {
            Globals.quitLoading();
        }
    }

    render() {
        const { show, onClose } = this.props;
        const { start_date, end_date, selected_product, products_list, all_products, loading } = this.state;

        return (
            <BModal show={show} onHide={onClose} size="lg" centered>
                <BModal.Header closeButton style={{ borderBottom: 'none', paddingBottom: 0 }}>
                    <BModal.Title style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                        {this.state.id ? 'Editar productos a promover' : 'Agregar productos a promover'}
                    </BModal.Title>
                </BModal.Header>
                <BModal.Body style={{ paddingTop: 0 }}>
                    <p style={{ fontWeight: 'bold', color: '#1B2733', marginBottom: '10px', marginTop: '20px' }}>Periodo de la campaña</p>
                    <div className="row mb-4">
                        <div className="col-md-6">
                            <Input
                                color=""
                                className="material"
                                labelClass="material"
                                label="Desde"
                                type="date"
                                value={start_date}
                                onChange={(e) => this.setState({ start_date: e.target.value })}
                            />
                        </div>
                        <div className="col-md-6">
                            <Input
                                color=""
                                className="material"
                                labelClass="material"
                                label="Hasta"
                                type="date"
                                value={end_date}
                                onChange={(e) => this.setState({ end_date: e.target.value })}
                            />
                        </div>
                    </div>

                    <p style={{ fontWeight: 'bold', color: '#1B2733', marginBottom: '10px' }}>Productos a los que aplica</p>
                    <div className="row mb-4 align-items-end">
                        <div className="col-md-9">
                            <SelectSearch
                                label="Buscar producto por nombre"
                                placeholder={loading ? 'Cargando productos...' : 'Buscar producto por nombre'}
                                options={all_products}
                                value={selected_product}
                                onChange={(data) => this.setState({ selected_product: data })}
                            />
                        </div>
                        <div className="col-md-3">
                            <Button color="primary" onClick={this.handleAddProduct} style={{ borderRadius: '20px', width: '100%' }}>
                                <Icon name="plus" /> Agregar
                            </Button>
                        </div>
                    </div>

                    {products_list.length > 0 && (
                        <div style={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid #eee' }}>
                            <Table
                                header={['Producto', 'Código', '']}
                                data={products_list.length}
                                style={{ margin: 0 }}
                            >
                                {products_list.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.product_name}</td>
                                        <td>{item.product_code || 'N/A'}</td>
                                        <td style={{ textAlign: 'right' }}>
                                            <span style={{ cursor: 'pointer', color: '#dc3545' }} onClick={() => this.handleRemoveProduct(index)}>
                                                <Icon name="trash" />
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </Table>
                        </div>
                    )}
                    
                    <div className="d-flex justify-content-center mt-4 mb-2">
                        <Button 
                            color="primary" 
                            onClick={this.save} 
                            style={{ width: '150px' }}
                            disabled={products_list.length === 0}
                        >
                            Guardar
                        </Button>
                    </div>
                </BModal.Body>
            </BModal>
        );
    }
}

export default ModalProductPromoted;
